<template>
  <div>
    <BtnAutoAdjustment v-if="sizeType === 'auto_adjustment'" :item="item" />
    <BtnXBig v-else-if="sizeType === 'btn_x_big'" :item="item" />
    <BtnBig v-else-if="sizeType === 'btn_big'" :item="item" />
  </div>
</template>

<script>
import BtnXBig from './sizeTypes/BtnXBig'
import BtnBig from './sizeTypes/BtnBig'
import BtnAutoAdjustment from './sizeTypes/BtnAutoAdjustment'

export default {
  name: 'ButtonItemPreview',
  components: { BtnAutoAdjustment, BtnBig, BtnXBig },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    sizeType () {
      return this.item.itemableAttributes.sizeType
    }
  }
}
</script>
